<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

@if (errorWhileInitializing) {
  <div class="profile:flex profile:min-h-50 profile:justify-center profile:items-center">
    <profile-pds-p-text p-text size="md" align="center">{{ 'pidpaw.generic.error.initialisation' | translate }} </profile-pds-p-text>
  </div>
}

@if (!errorWhileInitializing) {
  @if (isLoading$ | async) {
    @if (announceLoading()) {
      <span class="profile:sr-only" role="status" aria-live="polite" aria-atomic="true">
        {{ 'phoneWidget.general.loadingStatus' | translate }}
      </span>
    }
    @if (mode === MyProfileWidgetMode.PROFILE) {
      <pidx-skeleton-loader></pidx-skeleton-loader>
    }
  } @else {
    @if (!isAddPhoneTemplate(true)) {
      @if ((mfaSmsEnrolled$ | async) && mfaInfoActive()) {
        <div class="profile:w-full profile:md:w-2/3">
          <profile-pds-p-inline-notification
            p-inline-notification
            (dismiss)="dismissMfaInfo()"
            class="profile:mb-fluid-md"
            data-protractor-id="mfa-info-notification"
          >
            <slot>
              <profile-pds-p-text p-text size="sm">
                {{ 'pidp.phonenumbers_banner_text' | translate }}
              </profile-pds-p-text>
              <div class="profile:mt-fluid-sm">
                <profile-pds-p-button-pure
                  (click)="goToPorscheIdChangePage()"
                  p-button-pure
                  icon="arrow-right"
                  data-protractor-id="mfa-maintain-trigger-button"
                  >{{ 'pidp.phonenumbers_banner_button_mfa' | translate }}
                </profile-pds-p-button-pure>
              </div>
            </slot>
          </profile-pds-p-inline-notification>
        </div>
      }
      <div class="profile:mt-fluid-md profile:flex profile:flex-col profile:md:flex-row">
        <div class="profile:w-full profile:md:w-1/4 profile:md:pe-static-sm">
          <profile-pds-p-text p-text size="sm" color="contrast-medium"
            >{{ 'pidpaw.editPhones.headline.primaryMobile' | translate }}
          </profile-pds-p-text>
        </div>
        <div class="profile:w-full profile:md:w-1/2 profile:mt-fluid-md profile:md:mt-0">
          @if (errorMessage$ | async) {
            <pidx-inline-form-messages [messages]="[errorMessage$ | async | translate]"></pidx-inline-form-messages>
          }
          @if ((isCnUser$ | async) && restrictGlobalUIChanges) {
            <profile-pds-p-inline-notification
              p-inline-notification
              class="profile:mb-fluid-md"
              [dismissButton]="false"
              description="{{ 'pidpaw.cnViewOrEditRestrictionDisclaimer.message' | translate }}"
            >
            </profile-pds-p-inline-notification>
          }
          <myprofile-phone-list
            data-protractor-id="phone-list-only-standard"
            [mode]="MyProfileListMode.ONLY_STANDARD"
            [phones]="(phones$ | async) ?? []"
            [phoneBeingEdited]="tmpPhone$ | async"
            [hasConfirmedVehicle]="hasConfirmedVehicle"
            [isCnUser]="(isCnUser$ | async) ?? false"
            [restrictGlobalUIChanges]="restrictGlobalUIChanges"
            (goToChangePorscheIdPageEvent)="goToPorscheIdChangePage()"
            (verificationSuccessful)="newPhoneVerified.emit()"
          ></myprofile-phone-list>
        </div>
      </div>
      @if (((phones$ | async)?.length ?? 0) > 1) {
        <div class="profile:mt-fluid-md profile:flex profile:flex-col profile:md:flex-row">
          <div class="profile:w-full profile:md:w-1/4 profile:md:pe-static-sm">
            <profile-pds-p-text p-text size="sm" color="contrast-medium"
              >{{ 'pidpaw.editPhones.headline.additionalPhones' | translate }}
            </profile-pds-p-text>
          </div>
          <div class="profile:w-full profile:md:w-1/2 profile:mt-fluid-md profile:md:mt-0">
            <myprofile-phone-list
              data-protractor-id="phone-list-only-additional"
              [mode]="MyProfileListMode.ONLY_ADDITIONAL"
              [phones]="(phones$ | async) ?? []"
              [phoneBeingEdited]="tmpPhone$ | async"
              [hasConfirmedVehicle]="hasConfirmedVehicle"
              [isCnUser]="(isCnUser$ | async) ?? false"
              [restrictGlobalUIChanges]="restrictGlobalUIChanges"
              (goToChangePorscheIdPageEvent)="goToPorscheIdChangePage()"
              (verificationSuccessful)="newPhoneVerified.emit()"
            ></myprofile-phone-list>
          </div>
        </div>
      }
    }
    <!--  Add Phone Toggle-->
    @if (isAddPhoneTemplate(true)) {
      @if (!(isCnUser$ | async) || ((isCnUser$ | async) && !restrictGlobalUIChanges)) {
        <div class="profile:mt-fluid-md profile:flex profile:flex-col profile:md:flex-row">
          <div class="profile:w-full profile:md:w-1/4 profile:md:pe-static-sm">
            <profile-pds-p-text id="addNewPhoneNumberHeadline" p-text size="sm" color="contrast-medium">
              {{ 'pidpaw.editPhone.headline.addNewPhone' | translate }}
            </profile-pds-p-text>
          </div>
          <div class="profile:w-full profile:md:w-1/2 profile:mt-fluid-md profile:md:mt-0">
            <div>
              <myprofile-phone-editform
                [hasConfirmedVehicle]="hasConfirmedVehicle"
                (goToChangePorscheIdPageEvent)="goToPorscheIdChangePage()"
              >
              </myprofile-phone-editform>
            </div>
          </div>
        </div>
      }
    } @else {
      @if (!(isCnUser$ | async) || ((isCnUser$ | async) && !restrictGlobalUIChanges)) {
        <div class="profile:flex profile:flex-col profile:md:flex-row">
          <div class="profile:w-full profile:md:w-1/4 profile:md:pe-static-sm"></div>
          <div class="profile:w-full profile:md:w-1/2 profile:mt-fluid-md profile:md:mt-0">
            @if (isAddPhoneTemplate() && !maxNumbersReached()) {
              <profile-pds-p-button
                p-button
                class="profile:mt-fluid-md"
                variant="secondary"
                icon="plus"
                data-protractor-id="phone-widget-add-phone-number-button"
                id="add-phone-number-button"
                (click)="enterAddPhoneMode()"
                [myprofileUiTrack]="{
                  clickElementType: 'button',
                  clickElementId: 'phonenumber',
                  clickElementName: 'add',
                }"
                >{{ 'pidpaw.generic.button.addPhone.label' | translate }}
              </profile-pds-p-button>
            }
            @if (isAddPhoneTemplate() && maxNumbersReached()) {
              <profile-pds-p-text p-text data-protractor-id="phone-widget-too-many-phone-numbers-hint">
                {{ 'pidpaw.editPhone.label.tooManyPhones' | translate }}
              </profile-pds-p-text>
            }
          </div>
        </div>
      }
    }
  }
}

<!--  Add Phone Container-->
